import { ChangeDetectorRef, Component, OnInit, ViewChild, HostBinding, TemplateRef, ViewEncapsulation } from '@angular/core';
import * as _ from 'underscore';
import { GenericColDef } from '../../models/grid-context';
import { CommonService } from '../../services/common/common.service';
import { RestService } from '../../services/rest/rest.service';
import { DocumentListComponent } from '../document-list/document-list.component';
import { DrDocument } from '../../models/dr-document';

@Component({
    standalone: false,
    selector: 'res-exception-list',
    templateUrl: './exception-list.component.html',
    styleUrls: ['./exception-list.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ExceptionListComponent implements OnInit {
    @ViewChild('exceptionListGrid', { static: true }) exceptionListGrid: DocumentListComponent;
    @HostBinding('class') classes = 'maximized-component';
    @ViewChild('headerTemplate', { static: true }) headerTemplate: TemplateRef<any>;

    columnDefs: Array<GenericColDef>;

    constructor(public changeDetector: ChangeDetectorRef, private commonService: CommonService, private restService: RestService) { }

    responseCallback = (response: any) => {
        if (response && response.documents) {
            const documents = (<Array<any>>response.documents).map(t => new DrDocument(t));
            response.totalCount = response.view.documentCount;
            response.documents = documents;
        }
    }

    ngOnInit(): void {
        this.loadData();
    }

    loadData(): void {
        this.exceptionListGrid.isDocumentViewerExceptionList = true;
        this.exceptionListGrid.selectedTreeItemChanged(this.commonService.selectedNavigationNode);
    }

}
